import { z } from 'zod';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const inventoryProductParamsSchema = z.object({
  productId: z.string().regex(UUID_REGEX),
});

export type InventoryProductParamsInput = {
  productId?: string;
};

export type InventoryProductRouteParams = z.infer<typeof inventoryProductParamsSchema>;

export function normalizeInventoryProductParams(
  params: InventoryProductParamsInput,
): InventoryProductRouteParams | null {
  const parsed = inventoryProductParamsSchema.safeParse(params);
  if (!parsed.success) return null;
  return parsed.data;
}
